export default "__VITE_PUBLIC_ASSET__48a8522e__"